import * as React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

export default function ErrorAlert() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      Something went Wrong.
    </Alert>
  );
}
